var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticClass:"jsoneditorClass",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.jsonEditBoxId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }